export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-home-heart-line',
      title: 'Move-In Ready Homes',
      description: 'All our rental properties are thoroughly inspected, cleaned, and ready for you to move in immediately.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Fair and transparent rental rates with no hidden fees or surprise charges.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Prime Locations',
      description: 'Properties located in safe, convenient neighborhoods with easy access to schools, shopping, and transportation.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Professional Maintenance',
      description: 'Quick response to maintenance requests with qualified professionals handling all repairs.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Simple Application',
      description: 'Straightforward rental application process with clear requirements and fast approval times.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Credit Flexibility',
      description: 'We consider applicants with various credit profiles and work to find solutions that fit your situation.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Rent with TREX RE LLC?
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            We're committed to providing exceptional rental experiences that go beyond just finding you a place to live.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-5">
                <i className={`${benefit.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
